import TenantManagement from "@/components/TenantManagement";

const OrganizationsPage = () => (
  <section className="space-y-6">
    <header>
      <h1 className="heading-display text-2xl">Organizations</h1>
      <p className="mt-1 text-sm text-muted-foreground">Manage customer organizations and tenant access.</p>
    </header>
    <TenantManagement />
  </section>
);

export default OrganizationsPage;
